import { useQuery } from "react-query";
import axios from "axios";

const getCompanyTags = async ({ companyId }) => {
  const { data: companyTags } = await axios.get(
    `/api/v2/companies/${companyId}/tags`
  );

  return companyTags;
};

export default function useCompanyTags({
  companyId,
  refetchOnWindowFocus = false,
}) {
  return useQuery(
    ["companies", companyId, "tags"],
    () => getCompanyTags({ companyId }),
    {
      enabled: companyId !== undefined,
      refetchOnWindowFocus: refetchOnWindowFocus,
    }
  );
}
